/**
 * Get image alt text from product data
 * Priority: alt_text from media object > product title > fallback
 *
 * @package
 */

/**
 * Get alt text for an image from product data
 *
 * @param {Object} productData Product data from REST API.
 * @param {string} fallback    Fallback alt text if none found.
 * @return {string} Alt text for the image.
 */
export const getImageAltText = ( productData, fallback = 'Product' ) => {
	if ( ! productData ) {
		return fallback;
	}

	// Check for alt_text from embedded featured media.
	if (
		productData._embedded &&
		productData._embedded[ 'wp:featuredmedia' ] &&
		productData._embedded[ 'wp:featuredmedia' ][ 0 ] &&
		productData._embedded[ 'wp:featuredmedia' ][ 0 ].alt_text
	) {
		const altText = productData._embedded[ 'wp:featuredmedia' ][ 0 ].alt_text.trim();
		if ( altText ) {
			return altText;
		}
	}

	// Fallback to product title.
	if ( productData.title?.rendered ) {
		return productData.title.rendered;
	}

	return fallback;
};
